import store from '@/store'

const { body } = document
const WIDTH = 768
const RATIO = 3

export default {
  watch: {
    $route(route) {
      if (this.device === 'mobile' && !this.hideSidebar) {
        this.hideSidebar = true 
        this.isCollapse = true
      }
    }
  },
  beforeMount() {
    window.addEventListener('resize', this.resizeHandler)
  },
  mounted() {
    const isMobile = this.isMobile()
    if (isMobile) {
      store.dispatch('toggleDevice', 'mobile')
      this.hideSidebar = true  //如果屏幕很小，收缩左边菜单
      this.isCollapse = true
    }
  },
  methods: {
    isMobile() {
      const rect = body.getBoundingClientRect()
      return rect.width - RATIO < WIDTH
    },
    resizeHandler() {
      if (!document.hidden) {
        const isMobile = this.isMobile()
        store.dispatch('toggleDevice', isMobile ? 'mobile' : 'desktop')

        if (isMobile) {
          this.hideSidebar = true 
          this.isCollapse = true
        }
      }
    }
  }
}
